module.exports = __webpack_public_path__ + "static/media/ball_5_3.6a5144a2.mp3";